<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="data"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:[`item.network`]="{ item }">
           <v-icon :color="getColor(item.network)">mdi-checkbox-blank-circle</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import utils from '@/services/utils'
  export default {
    props: {
      devices: {
        type: Array,
        required: false,
        default: []
      }
    },
    data () {
      return {
        headers: [
          {
            text: '',
            align: 'start',
            value: 'network',
          },
          { text: 'Unit ID', value: 'serial' },
          { text: 'Nombre', value: 'name' },
        ],
        data: []
      }
    },
    watch: {
      devices (newValue) {
        this.data = newValue
      }
    },
    mounted () {
      if (this.devices) this.data = this.devices
    },
    methods: {
      getColor (value) {
        return utils.getColor(value)
      },
    },
  }
</script>